import Swiper from 'swiper'
import { Autoplay, Navigation, Pagination } from 'swiper/modules'

import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

const initializeEventsSwiper = (): void => {
    new Swiper('.events__swiper', {
        modules: [Pagination, Navigation, Autoplay],
        spaceBetween: 30,
        slidesPerView: 1,
        roundLengths: true,
        loop: true,
        speed: 500,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        loopAdditionalSlides: 1,
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true,
            renderBullet: (index: number, className: string) => `<span id="${index}" class="${className}"></span>`,
        },
    })
}

initializeEventsSwiper()
